import React from 'react';
import { ProductPart } from '../../types/mold';
import TableComponent from './TableComponent';
import { GenericColumn } from '../KanbanBoard/utils/tableColumns';
import CustomerCodeLabel from './CustomerCodeLabel';

interface PartTableProps {
    productParts: ProductPart[];
    renderActions: (part: ProductPart) => React.ReactNode;
    hideAction?: boolean;
}

const PartTable: React.FC<PartTableProps> = ({ productParts, renderActions, hideAction = false }) => {
    const columns: GenericColumn<ProductPart>[] = [
        {
            key: 'partNumber',
            label: 'รหัสชิ้นงาน',
            sortable: true,
            filterable: true,
            render: (part) => part.partNumber,
            filterOptions: (parts) => [...new Set(parts.map(part => part.partNumber))],
            getFilterValue: (part) => part.partNumber,
            toCSV: (part) => part.partNumber,
        },
        {
            key: 'partName',
            label: 'ชื่อชิ้นงาน',
            sortable: true,
            filterable: true,
            render: (part) => part.partName,
            filterOptions: (parts) => [...new Set(parts.map(part => part.partName))],
            getFilterValue: (part) => part.partName,
            toCSV: (part) => part.partName,
        },
        {
            key: 'model',
            label: 'รุ่น',
            sortable: true,
            filterable: true,
            render: (part) => part.model,
            filterOptions: (parts) => [...new Set(parts.map(part => part.model))],
            getFilterValue: (part) => part.model,
            toCSV: (part) => part.model,
        },
        {
            key: 'history',
            label: 'History',
            sortable: true,
            filterable: true,
            render: (part) => part.history,
            filterOptions: (parts) => [...new Set(parts.map(part => part.history))],
            getFilterValue: (part) => part.history,
            toCSV: (part) => part.history,
        },
        {
            key: 'customer',
            label: 'รหัสลูกค้า',
            sortable: true,
            filterable: true,
            render: (part) => (<CustomerCodeLabel customer={part.customer} />),
            filterOptions: (parts) => [...new Set(parts.map(part => part.customer.code))],
            getFilterValue: (part) => part.customer.code,
            toCSV: (part) => part.customer.code,
        },
        {
            key: 'status',
            label: 'สถานะ',
            sortable: true,
            filterable: true,
            render: (part) => {
                const isActive = part.status === 'active' || part.status === ''
                const bgColor = isActive ? 'bg-green-100' : 'bg-red-100';
                const textColor = isActive ? 'text-green-800' : 'text-red-800';
                return (<span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${bgColor} ${textColor}`}>
                    {isActive ? 'ใช้งาน' : 'ไม่ใช้งาน'}
                </span>)
            },
            filterOptions: (parts) => [...new Set(parts.map(part => part.status))],
            getFilterValue: (part) => part.status,
            toCSV: (part) => part.status,
        }
    ];

    // Add action column if needed
    if (!hideAction) {
        columns.push({
            key: 'actions',
            label: 'Actions',
            sortable: false,
            filterable: false,
            render: (part) => renderActions(part)
        });
    }

    return (
        <div>
            <TableComponent<ProductPart>
                data={productParts}
                columns={columns}
                pagination={true}
                initialPageSize={10}
                defaultSortKey="partNumber"
                savePreferenceSettings={{
                    isEnable: true,
                    key: 'partTable',
                }}
            />
        </div>
    );
};

export default PartTable;